<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text class="d-flex">
      <v-avatar
        rounded
        size="120"
        class="me-6"
      >
        <v-img :src="$store.state.galleryItems[0] || $store.getters.avatarUrl"></v-img>
      </v-avatar>
      <div>
        <v-btn
          color="primary"
          class="me-3 mt-5"
          @click="$store.commit('showGallery', { open: true, list: false })"
        >
          <v-icon class="d-sm-none">
            {{ icons.mdiCloudUploadOutline }}
          </v-icon>
          <span class="d-none d-sm-block">Upload new photo</span>
        </v-btn>

        <!-- <input
          ref="refInputEl"
          type="file"
          accept=".jpeg,.png,.jpg,GIF"
          :hidden="true"
        /> -->

        <!-- <v-btn
          color="error"
          outlined
          class="mt-5"
        >
          Reset
        </v-btn> -->
        <p class="text-sm mt-5">
          Allowed JPG, GIF or PNG.
        </p>
      </div>
    </v-card-text>

    <v-card-text>
      <v-form
        ref="accountForm"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="accountData.username"
              label="Username"
              :error-messages="fieldErrors.username"
              dense
              outlined
              counter="30"
              class="mb-5"
              @blur="validateField('username')"
              @input="clearFieldError('username')"
            >
              <v-icon
                slot="append"
                color="#56ca00"
              >
                {{ icons.mdiCheckCircle }}
              </v-icon>

              <v-icon
                slot="append"
                color="#ff4c51"
              >
                {{ icons.mdiAlertCircle }}
              </v-icon>
            </v-text-field>

            <v-text-field
              v-model="accountData.name"
              label="Name"
              :error-messages="fieldErrors.name"
              dense
              outlined
              counter="80"
              class="mb-5"
              @blur="validateField('name')"
              @input="clearFieldError('name')"
            ></v-text-field>

            <v-text-field
              v-model="accountData.email"
              label="E-mail"
              dense
              outlined
              disabled
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="4"
            md="6"
            class="d-none d-sm-flex justify-center position-relative"
          >
            <!-- <v-img
              contain
              max-width="170"
              src="@/assets/images/3d-characters/pose-m-1.png"
              class="security-character"
            ></v-img> -->
            <v-textarea
              v-model="accountData.bio"
              height="168px"
              outlined
              rows="7"
              label="Bio"
              :error-messages="fieldErrors.bio"
              counter="500"
              @blur="validateField('bio')"
              @input="clearFieldError('bio')"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="accountData.profile_phrase"
              label="Public profile phrase"
              hint="Shown beneath your name on your public profile."
              persistent-hint
              outlined
              dense
              counter="180"
              maxlength="180"
              :error-messages="fieldErrors.profile_phrase"
              @blur="validateField('profile_phrase')"
              @input="clearFieldError('profile_phrase')"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-alert
              v-if="message.status === 0"
              dense
              outlined
              type="error"
            >
              <div>{{ message.text }}</div>
              <div
                v-for="(validationError, index) in validationSummary"
                :key="`${validationError}-${index}`"
              >
                - {{ validationError }}
              </div>
            </v-alert>
            <v-alert
              v-if="message.status === 1"
              dense
              text
              type="success"
            >
              {{ message.text }}
            </v-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="account-actions"
          >
            <!-- <v-divider></v-divider> -->
            <!-- <v-btn
              color="secondary"
              outlined
              type="reset"
              @click.prevent="resetForm"
            >
              Cancel
            </v-btn> -->
            <v-btn
              color="primary"
              :loading="loading"
              :disabled="loading"
              @click="updateUserData()"
            >
              Save changes
            </v-btn>
            <v-btn
              outlined
              color="primary"
              to="/import-data"
            >
              <v-icon left>
                {{ icons.mdiDatabaseImportOutline }}
              </v-icon>
              Import Facebook Data
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import {
  mdiAlertOutline, mdiCloudUploadOutline, mdiCheckCircle, mdiAlertCircle, mdiDatabaseImportOutline,
} from '@mdi/js'

// import { ref } from '@vue/composition-api'

export default {
  props: ['accountData'],
  data() {
    return {
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
        mdiCheckCircle,
        mdiAlertCircle,
        mdiDatabaseImportOutline,
      },
      endpoint: process.env.VUE_APP_ROOT_API,
      loading: false,
      message: {
        status: null,
        text: null,
      },
      validationSummary: [],
      fieldErrors: {
        username: [],
        name: [],
        bio: [],
        profile_phrase: [],
      },
    }
  },
  methods: {
    getUsernameErrors(rawValue) {
      const value = (rawValue || '').trim()
      const errors = []

      if (!value) {
        errors.push('Username is required.')
      }

      if (value && value.length < 3) {
        errors.push('Username must have at least 3 characters.')
      }

      if (value.length > 30) {
        errors.push('Username must have at most 30 characters.')
      }

      if (value && !/^[a-zA-Z0-9._-]+$/.test(value)) {
        errors.push('Username can only contain letters, numbers, dot, underscore and hyphen.')
      }

      return errors
    },
    getNameErrors(rawValue) {
      const value = (rawValue || '').trim()
      const errors = []

      if (!value) {
        errors.push('Name is required.')
      }

      if (value && value.length < 2) {
        errors.push('Name must have at least 2 characters.')
      }

      if (value.length > 80) {
        errors.push('Name must have at most 80 characters.')
      }

      return errors
    },
    getBioErrors(rawValue) {
      const value = (rawValue || '').trim()
      const errors = []

      if (value.length > 500) {
        errors.push('Bio must have at most 500 characters.')
      }

      return errors
    },
    validateField(field) {
      if (field === 'username') {
        this.fieldErrors.username = this.getUsernameErrors(this.accountData.username)
      }

      if (field === 'name') {
        this.fieldErrors.name = this.getNameErrors(this.accountData.name)
      }

      if (field === 'bio') {
        this.fieldErrors.bio = this.getBioErrors(this.accountData.bio)
      }

      if (field === 'profile_phrase') {
        const value = (this.accountData.profile_phrase || '').trim()
        this.fieldErrors.profile_phrase = value.length > 180 ? ['Profile phrase must have at most 180 characters.'] : []
      }
    },
    clearFieldError(field) {
      if (this.fieldErrors[field] && this.fieldErrors[field].length) {
        this.validateField(field)
      }
    },
    validateProfileData() {
      this.validateField('username')
      this.validateField('name')
      this.validateField('bio')
      this.validateField('profile_phrase')

      this.validationSummary = [
        ...this.fieldErrors.username,
        ...this.fieldErrors.name,
        ...this.fieldErrors.bio,
        ...this.fieldErrors.profile_phrase,
      ]

      return this.validationSummary.length === 0
    },
    async updateUserData() {
      const isValid = this.validateProfileData()

      if (!isValid) {
        this.message = {
          status: 0,
          text: 'Please review the validation messages and fix the highlighted fields.',
        }

        return
      }

      if (!this.endpoint) {
        this.message = {
          status: 0,
          text: 'Missing API endpoint configuration (VUE_APP_ROOT_API).',
        }

        return
      }

      this.loading = true
      this.validationSummary = []
      this.message.status = null

      const selectedAvatar = this.$store.state.galleryItems[0]
      const userAvatar = selectedAvatar
        ? selectedAvatar.split('.com/')[1].split('?X-Amz')[0]
        : (this.$store.state.user && this.$store.state.user.extra_data.avatar) || ''

      const payload = {
        username: this.accountData.username.trim(),
        name: this.accountData.name.trim(),
        bio: this.accountData.bio ? this.accountData.bio.trim() : '',
        profile_phrase: (this.accountData.profile_phrase || '').trim().replace(/\s+/g, ' '),
        avatar: userAvatar,
      }

      try {
        await axios.post(`${this.endpoint}/updateUserData`, payload, {
          headers: {
            Authorization: this.$store.state.jwtToken,
          },
        })

        const currentUser = this.$store.state.user || { extra_data: {} }
        this.$store.commit('setUser', {
          ...currentUser,
          extra_data: {
            ...currentUser.extra_data,
            ...payload,
          },
        })

        localStorage.setItem('user_name', payload.name)

        this.message = {
          status: 1,
          text: 'Profile updated successfully.',
        }
      } catch (error) {
        const backendMessage = error && error.response && error.response.data && error.response.data.message
        this.message = {
          status: 0,
          text: backendMessage || 'Could not update your profile right now.',
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.account-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 599px) {
    .v-btn {
      width: 100%;
      min-height: 40px;
      height: auto;
      margin: 0;
      padding: 10px 12px;
      white-space: normal;
    }

    ::v-deep .v-btn__content { flex: 1 1 auto; }
  }
}
</style>
